import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export function usePoll(url, ms = 5000, params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params || {});
  const alive = useRef(true);

  const load = useCallback(async () => {
    try {
      const r = await api.get(url, { params: JSON.parse(key) });
      if (alive.current) setData(r.data);
    } catch (e) {
      // keep last data on transient errors
    } finally {
      if (alive.current) setLoading(false);
    }
  }, [url, key]);

  useEffect(() => {
    alive.current = true;
    load();
    const t = ms ? setInterval(load, ms) : null;
    return () => {
      alive.current = false;
      if (t) clearInterval(t);
    };
  }, [load, ms]);

  return { data, loading, reload: load, setData };
}
